// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  background: #f9f9f9;
}

.kiosk {
  max-width: 90%;
  margin: 0 auto;
  background: #fff;
  padding: 2rem;
  box-shadow: 0 0 3px 0 #eee;
}

.section {
  margin: 2rem 0;
}

.search {
  /* width: 70%; */
  padding: 1rem;
  font-size: 2rem;
  flex: 1 1;
  margin-right: 0.25rem;
}

.search-list {
  list-style-type: none;
}

.search-item {
  padding: 1rem;
  border: 1px solid #2c82c5;
  font-size: 2rem;
  margin-bottom: 1rem;
  line-height: 1.5rem;
  cursor: pointer;
  border-radius: 5px;
  background: #2c82c5;
  color: #fff;
}

.search-item-small {
  font-size: 1rem;
}

.search-wrap {
  display: flex;
}

.numpad {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.numpad-key {
  width: 30%;
  text-align: center;
  margin: 0.5rem;
  height: 75px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  border-radius: 100%;
  background: #2c82c5;
  color: #fff;
  font-size: 2rem;
  border-radius: 5px;
}

.numpad-key:active {
  background: #000;
  color: #fff;
}

.checkin-notes {
  width: 100%;
  padding: 1rem;
  font-size: 2rem;
  border-radius: 5px;
  border: 1px solid #2c82c5;
}

.button {
  line-height: 37px;
  padding: 1rem;
  margin: 0 0.25rem;
  height: 73px;
  background: #2c82c5;
  color: #fff;
  display: inline-block;
  border-radius: 5px;
}

*:not(input[type="text"]),
.button,
.numpad-key span {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

.button.full {
  width: 100%;
  margin: 0;
}

.search-buttons .button {
  padding: 1rem 3rem;
  font-size: 2rem;
}

.flex-centered > div {
  width: 100%;
}

.flex-centered > div.center {
  text-align: center;
}

.flex-centered > div.right {
  text-align: right;
}

input:disabled {
  background: #fff;
  border: 1px solid #2c82c5;
  border-radius: 5px;
  color: #000 !important;
  -webkit-text-fill-color: #000000;
  opacity: 1;
}

.single-screen {
  text-align: center;
}

.single-screen .button-wrap {
  display: flex;
}

.single-screen .button-wrap > div {
  margin: 1rem;
}

.section-wrap {
  margin: 1rem 0;
}

.single-screen .button-wrap .button {
  font-size: 2rem;
}

.single-screen .button-wrap .button.half {
  width: 50%;
}

.single-screen h1 {
  font-size: 4rem;
}

.quick-notes-wrap {
  display: flex;
  padding: 0 1rem;
  justify-content: space-evenly;
}

.quick-notes-wrap .button {
  width: 100%;
  background: #000;
  text-transform: uppercase;
  font-size: 0.8rem;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-results {
  padding: 0 1rem;
  font-size: 2rem;
}

.button:active,
.search-item:active {
  background: #000;
}

.button.checkin {
  background: #23c67a;
}

.button.checkout {
  background: #ff3d3d;
}

.button.processing {
  font-size: 0 !important;
}

.circle-loader {
  margin-bottom: 0;
  margin-top: -7px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-left-color: #fff;
  animation: loader-spin 1.2s infinite linear;
  position: relative;
  display: none;
  vertical-align: top;
  border-radius: 50%;
  width: 56px;
  height: 56px;
}

.load-complete {
  animation: none;
  border-color: #fff;
  transition: border 500ms ease-out;
}

.checkmark {
  display: none;
}

.checkmark.draw:after {
  animation-duration: 800ms;
  animation-timing-function: ease;
  animation-name: checkmark;
  transform: scaleX(-1) rotate(135deg);
}

.checkmark:after {
  opacity: 1;
  height: 28px;
  width: 14px;
  transform-origin: left top;
  border-right: 3px solid #fff;
  border-top: 3px solid #fff;
  content: "";
  left: 12px;
  top: 28px;
  position: absolute;
}

@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: 14px;
    opacity: 1;
  }
  40% {
    height: 28px;
    width: 14px;
    opacity: 1;
  }
  100% {
    height: 28px;
    width: 14px;
    opacity: 1;
  }
}

/** Mobile stylin' **/
@media screen and (max-device-width: 750px) {
  .logo {
    width: 100px;
    height: auto;
  }

  .kiosk {
    max-width: 100%;
    padding: 1rem 0;
  }

  .search-wrap {
    flex-wrap: flex;
    padding: 0 1rem;
  }

  .search {
    max-width: 90%;
    font-size: small;
    padding: 0.25rem;
    text-align: center;
  }

  .search-list {
    padding: 0 1rem;
  }

  .search-item {
    font-size: 1.5rem;
  }

  .search-buttons .button {
    padding: 1rem;
    font-size: 1rem;
  }

  .numpad {
    padding: 0 1rem;
  }

  .numpad-key {
    margin: 0.25rem;
  }

  .single-screen h1,
  .single-screen h3 {
    font-size: initial;
  }

  .quick-notes-wrap {
    flex-wrap: wrap;
  }

  .quick-notes-wrap .button {
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
  }

  .checkin-notes {
    font-size: small;
  }

  .single-screen .button-wrap {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    padding: 0 1rem;
  }

  .single-screen .button-wrap .button {
    font-size: 1.5rem;
  }

  .single-screen .button-wrap .button.half {
    width: 100%;
  }

  .single-screen .button-wrap > div {
    margin: 1rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;EAClD,iBAAiB,EAAE,iFAAiF;AACtG;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EAEE,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,SAAS;IACT,QAAQ;IACR,UAAU;EACZ;EACA;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  background: #f9f9f9;\n}\n\n.kiosk {\n  max-width: 90%;\n  margin: 0 auto;\n  background: #fff;\n  padding: 2rem;\n  box-shadow: 0 0 3px 0 #eee;\n}\n\n.section {\n  margin: 2rem 0;\n}\n\n.search {\n  /* width: 70%; */\n  padding: 1rem;\n  font-size: 2rem;\n  flex: 1;\n  margin-right: 0.25rem;\n}\n\n.search-list {\n  list-style-type: none;\n}\n\n.search-item {\n  padding: 1rem;\n  border: 1px solid #2c82c5;\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  line-height: 1.5rem;\n  cursor: pointer;\n  border-radius: 5px;\n  background: #2c82c5;\n  color: #fff;\n}\n\n.search-item-small {\n  font-size: 1rem;\n}\n\n.search-wrap {\n  display: flex;\n}\n\n.numpad {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.numpad-key {\n  width: 30%;\n  text-align: center;\n  margin: 0.5rem;\n  height: 75px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 100%;\n  background: #2c82c5;\n  color: #fff;\n  font-size: 2rem;\n  border-radius: 5px;\n}\n\n.numpad-key:active {\n  background: #000;\n  color: #fff;\n}\n\n.checkin-notes {\n  width: 100%;\n  padding: 1rem;\n  font-size: 2rem;\n  border-radius: 5px;\n  border: 1px solid #2c82c5;\n}\n\n.button {\n  line-height: 37px;\n  padding: 1rem;\n  margin: 0 0.25rem;\n  height: 73px;\n  background: #2c82c5;\n  color: #fff;\n  display: inline-block;\n  border-radius: 5px;\n}\n\n*:not(input[type=\"text\"]),\n.button,\n.numpad-key span {\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\n}\n\n.button.full {\n  width: 100%;\n  margin: 0;\n}\n\n.search-buttons .button {\n  padding: 1rem 3rem;\n  font-size: 2rem;\n}\n\n.flex-centered > div {\n  width: 100%;\n}\n\n.flex-centered > div.center {\n  text-align: center;\n}\n\n.flex-centered > div.right {\n  text-align: right;\n}\n\ninput:disabled {\n  background: #fff;\n  border: 1px solid #2c82c5;\n  border-radius: 5px;\n  color: #000 !important;\n  -webkit-text-fill-color: #000000;\n  opacity: 1;\n}\n\n.single-screen {\n  text-align: center;\n}\n\n.single-screen .button-wrap {\n  display: flex;\n}\n\n.single-screen .button-wrap > div {\n  margin: 1rem;\n}\n\n.section-wrap {\n  margin: 1rem 0;\n}\n\n.single-screen .button-wrap .button {\n  font-size: 2rem;\n}\n\n.single-screen .button-wrap .button.half {\n  width: 50%;\n}\n\n.single-screen h1 {\n  font-size: 4rem;\n}\n\n.quick-notes-wrap {\n  display: flex;\n  padding: 0 1rem;\n  justify-content: space-evenly;\n}\n\n.quick-notes-wrap .button {\n  width: 100%;\n  background: #000;\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.no-results {\n  padding: 0 1rem;\n  font-size: 2rem;\n}\n\n.button:active,\n.search-item:active {\n  background: #000;\n}\n\n.button.checkin {\n  background: #23c67a;\n}\n\n.button.checkout {\n  background: #ff3d3d;\n}\n\n.button.processing {\n  font-size: 0 !important;\n}\n\n.circle-loader {\n  margin-bottom: 0;\n  margin-top: -7px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #fff;\n  animation: loader-spin 1.2s infinite linear;\n  position: relative;\n  display: none;\n  vertical-align: top;\n  border-radius: 50%;\n  width: 56px;\n  height: 56px;\n}\n\n.load-complete {\n  -webkit-animation: none;\n  animation: none;\n  border-color: #fff;\n  transition: border 500ms ease-out;\n}\n\n.checkmark {\n  display: none;\n}\n\n.checkmark.draw:after {\n  animation-duration: 800ms;\n  animation-timing-function: ease;\n  animation-name: checkmark;\n  transform: scaleX(-1) rotate(135deg);\n}\n\n.checkmark:after {\n  opacity: 1;\n  height: 28px;\n  width: 14px;\n  transform-origin: left top;\n  border-right: 3px solid #fff;\n  border-top: 3px solid #fff;\n  content: \"\";\n  left: 12px;\n  top: 28px;\n  position: absolute;\n}\n\n@keyframes loader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes checkmark {\n  0% {\n    height: 0;\n    width: 0;\n    opacity: 1;\n  }\n  20% {\n    height: 0;\n    width: 14px;\n    opacity: 1;\n  }\n  40% {\n    height: 28px;\n    width: 14px;\n    opacity: 1;\n  }\n  100% {\n    height: 28px;\n    width: 14px;\n    opacity: 1;\n  }\n}\n\n/** Mobile stylin' **/\n@media screen and (max-device-width: 750px) {\n  .logo {\n    width: 100px;\n    height: auto;\n  }\n\n  .kiosk {\n    max-width: 100%;\n    padding: 1rem 0;\n  }\n\n  .search-wrap {\n    flex-wrap: flex;\n    padding: 0 1rem;\n  }\n\n  .search {\n    max-width: 90%;\n    font-size: small;\n    padding: 0.25rem;\n    text-align: center;\n  }\n\n  .search-list {\n    padding: 0 1rem;\n  }\n\n  .search-item {\n    font-size: 1.5rem;\n  }\n\n  .search-buttons .button {\n    padding: 1rem;\n    font-size: 1rem;\n  }\n\n  .numpad {\n    padding: 0 1rem;\n  }\n\n  .numpad-key {\n    margin: 0.25rem;\n  }\n\n  .single-screen h1,\n  .single-screen h3 {\n    font-size: initial;\n  }\n\n  .quick-notes-wrap {\n    flex-wrap: wrap;\n  }\n\n  .quick-notes-wrap .button {\n    margin-bottom: 0.5rem;\n    font-size: 1.5rem;\n  }\n\n  .checkin-notes {\n    font-size: small;\n  }\n\n  .single-screen .button-wrap {\n    flex-wrap: wrap;\n    flex-direction: column-reverse;\n    padding: 0 1rem;\n  }\n\n  .single-screen .button-wrap .button {\n    font-size: 1.5rem;\n  }\n\n  .single-screen .button-wrap .button.half {\n    width: 100%;\n  }\n\n  .single-screen .button-wrap > div {\n    margin: 1rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
